<template>
  <div>
    <!-- data-hp is used to distinguish this element from other ads in testing -->
    <div
      ref="honeypot"
      class="product-ads-carousel ad-result mainline__result sidebar__result snippet result"
      data-test-id="mainline-result-ad"
      data-hp="true"
    />
    <EAdBlockNotice v-if="isHidden" />
  </div>
</template>

<script>
import EAdBlockNotice from './notice';
// import { MEDIUM, GENEROUS } from '~~/common/js/constants/timeouts';

export default {
  name: 'EAdBlockHoneyPot',
  components: {
    EAdBlockNotice,
  },
  data: () => ({
    isHidden: false,
  }),
  mounted() {
    // TODO: Temporarily disabled until we figure out why people are seeing the notice so often.

    // const honeyPotNode = this.$refs.honeypot;
    // const checkHoneyPot = () => {
    //   this.isHidden = honeyPotNode.offsetHeight === 0 ||
    //   honeyPotNode.offsetWidth === 0 ||
    //   !document.body.contains(honeyPotNode) ||
    //   honeyPotNode.style.display === 'none' ||
    //   honeyPotNode.style.visibility === 'hidden';
    // };
    // checkHoneyPot();
    // if (!this.isHidden) {
    //   // Allows re-checking shortly after
    //   // the page settles, and also facilitates
    //   // service testing.
    //   setTimeout(checkHoneyPot, MEDIUM);
    //   setTimeout(checkHoneyPot, GENEROUS);
    // }
  },
};
</script>

<style lang="scss" scoped>
.ad-result {
  height: 100px;
  width: 100px;
  position: fixed;
  top: -999px;
  left: -999px;
}
</style>
